import React from 'react';
import { useTranslation } from 'react-i18next';
import SaasSection from '../saas/Section';
import SaasContainer from '../saas/Container';
import Reveal from '../saas/Reveal';
import { ProcessBento } from './ProcessBento';
import LandingCollageScene from './LandingCollageScene';
import LandingCollageCard from './LandingCollageCard';

const ProcessSection = () => {
  const { t } = useTranslation();
  const steps = [t('process.item1'), t('process.item2'), t('process.item3'), t('process.item4')];

  return (
    <SaasSection variant="wash" className="relative overflow-x-hidden">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-[min(55vh,520px)] bg-[radial-gradient(ellipse_85%_60%_at_50%_0%,rgba(232,223,230,0.45)_0%,transparent_68%)]"
        aria-hidden
      />
      <SaasContainer className="relative">
        <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-12 lg:gap-16">
          <Reveal className="order-2 md:order-1">
            <LandingCollageCard
              glow={
                <>
                  <div
                    className="pointer-events-none absolute -start-24 -top-20 h-52 w-52 rounded-full bg-sky-bloom/30 blur-3xl"
                    aria-hidden
                  />
                  <div
                    className="pointer-events-none absolute -bottom-16 -end-20 h-48 w-48 rounded-full bg-signal/[0.07] blur-3xl"
                    aria-hidden
                  />
                </>
              }
            >
              <LandingCollageScene variant="process" embedded />
            </LandingCollageCard>
          </Reveal>

          <div className="order-1 space-y-7 text-center md:order-2 md:space-y-8">
            <div className="mx-auto flex w-full max-w-2xl flex-col items-center text-center">
              <Reveal>
                <p className="type-eyebrow mb-3">{t('process.eyebrow', { defaultValue: 'مسیر ورود' })}</p>
                <span
                  className="mb-4 inline-block h-1.5 w-14 rounded-full bg-gradient-to-r from-signal via-signal/70 to-sky-bloom/80 md:mb-5"
                  aria-hidden
                />
              </Reveal>
              <Reveal delayMs={40}>
                <h2 className="type-section-title text-balance text-2xl md:text-heading-lg">
                  {t('process.title')}
                </h2>
              </Reveal>
            </div>
            <Reveal delayMs={70}>
              <p className="type-lead mx-auto max-w-xl md:text-lg">
                {t('process.subtitle')}
              </p>
            </Reveal>
            <div className="mx-auto w-full max-w-xl md:max-w-2xl">
              <ProcessBento items={steps} />
            </div>
          </div>
        </div>
      </SaasContainer>
    </SaasSection>
  );
};

export default ProcessSection;
